"use client";
import { useReducer } from "react";

export default function useForceRender() {
  const [, forceRender] = useReducer((x) => x + 1, 0);
  return forceRender;
}
